import React from 'react'; 
import Icon from '@ant-design/icons';
import { LinkOutlined, FilePdfOutlined, FileWordOutlined, FileExcelOutlined,
    FileImageOutlined, PlayCircleOutlined, FileOutlined, AudioOutlined } from '@ant-design/icons';
import ScormIcon from './ScormIcon';

const FILE_ICON_MAP = {
    PDF: {
        key: 'PDF',
        transKey: 'file.type.pdf',
        icon: <FilePdfOutlined/>,
        checkFileType: ( fileType ) => [ 'application/pdf' ].includes( fileType )
    },
    WORD: {
        key: 'WORD',
        transKey: 'file.type.word',
        icon: <FileWordOutlined/>,
        checkFileType: ( fileType ) => [ 'application/msword', 
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ].includes( fileType )
    },
    EXCEL: {
        key: 'EXCEL',
        transKey: 'file.type.excel',
        icon: <FileExcelOutlined/>,
        checkFileType: ( fileType ) => [ 'application/vnd.ms-excel', 
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ].includes( fileType )
    },
    PPT: {
        key: 'PPT',
        transKey: 'file.type.ppt',
        icon: <FilePdfOutlined/>,
        checkFileType: ( fileType ) => [ 'application/vnd.ms-powerpoint', 
            'application/vnd.openxmlformats-officedocument.presentationml.presentation' ].includes( fileType )
    },
    IMAGE: {
        key: 'IMAGE',
        transKey: 'file.type.image',
        icon: <FileImageOutlined/>,
        checkFileType: ( fileType ) => fileType?.startsWith( 'image/' )
    },
    VIDEO: {
        key: 'VIDEO',
        transKey: 'file.type.video',
        icon: <PlayCircleOutlined/>,
        checkFileType: ( fileType ) => fileType?.startsWith( 'video/' )
    },
    AUDIO: {
        key: 'AUDIO',
        transKey: 'file.type.audio',
        icon: <AudioOutlined/>,
        checkFileType: ( fileType ) => fileType?.startsWith( 'audio/' )
    },
    URL: {
        key: 'URL',
        transKey: 'file.type.url',
        icon: <LinkOutlined/>,
        checkFileType: ( fileType ) => fileType?.startsWith( 'text/uri-list' )
    },
    SCORM: {
        key: 'SCORM',
        transKey: 'file.type.scorm',
        icon: <Icon component={ ScormIcon }/>,
        checkFileType: ( fileType ) => [ 'text/html' ].includes( fileType )
    },
    _: {
        key: 'OTHER',
        transKey: 'file.type.other',
        icon: <FileOutlined/>,
        checkFileType: () => true
    }
};

export default FILE_ICON_MAP;
 